import { useState, useEffect } from "react";
import axios from "axios";
import { useCallback } from "react";

export const useFetch = (url, method = "GET") => {
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState(null);

  const MAIN_URL = process.env.REACT_APP_API_URL;

  const postData = useCallback((postData) => {
    setOptions({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: postData,
    });
  }, []);

  const getData = useCallback(
    (url) => {
      setOptions({
        url: MAIN_URL + url,
        method: "GET",
      });
    },
    [MAIN_URL],
  );

  const deleteData = useCallback(
    (url) => {
      setOptions({
        url: MAIN_URL + url,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    [MAIN_URL],
  );

  useEffect(() => {
    const controller = new AbortController();

    async function fetchData(fetchOptions) {
      setIsPending(true);
      setIsSuccess(false);

      try {
        const res = await axios.request({
          ...fetchOptions,
          signal: controller.signal,
        });
        //console.log("🚀 ~ fetchData ~ res:", res.status, res.data);
        if (res.status < 200 || res.status >= 300) {
          // create error object and reject if not a 2xx response code
          let err = new Error("HTTP status code: " + res.status);
          err.response = res;
          err.status = res.status;
          throw err;
        }
        const contentType = res.headers["content-type"];
        let data;
        if (contentType && contentType.includes("application/json")) {
          data = await res.data;
          setData(data);
        }
        setIsSuccess(true);
        setIsPending(false);
        setError(null);
      } catch (err) {
        if (err.name === "AbortError") {
          console.log("the fetch was aborted");
        } else {
          console.log("fetch error: " + err);
          setIsPending(false);
          setIsSuccess(false);
          setError(err.message);
        }
      }
    }

    // default
    var fullUrl = MAIN_URL + url;
    if (method === "GET" && url) {
      //var fullUrl = MAIN_URL + url;
      console.log("🚀 ~ useEffect ~ fullUrl:", fullUrl);
      fetchData({
        url: fullUrl,
        method,
        headers: { "X-API-KEY": process.env.REACT_APP_API_KEY },
      });
    }

    // passed url after creation
    if (method === "GET" && options) {
      fetchData({ ...options });
    }

    // default post
    if (method === "POST" && options) {
      //var fullUrl = MAIN_URL + url;
      fetchData({ url: fullUrl, ...options });
    }

    //default delete
    if (method === "DELETE" && options) {
      fetchData({ ...options });
    }

    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, options, method]);

  return { data, isPending, isSuccess, error, postData, getData, deleteData };
};
